<template>
    <div>
        <div
                v-for="(moznost, index) in otazka.moznosti"
                class="custom-control custom-radio"
                :class="{
                    'image-radio': isImage(moznost.subor) || isVideo(moznost.subor),
                    'zvuk-radio': isAudio(moznost.subor),
                    'valid': showResult && moznost.label === otazka.spravna_odpoved,
                    'invalid': showResult && moznost.label !== otazka.spravna_odpoved && odpoved.input === moznost.label
                }"
                :key="index"
        >
            <input type="radio" class="custom-control-input" :id="moznost.label" :name="moznost.label" v-model="odpoved.input" :value="moznost.label" :disabled="showResult">
            <label class="custom-control-label" :for="moznost.label">
                <template v-if="isImage(moznost.subor)">
                    <img :src="skolyStorage + moznost.subor" alt="">
                </template>
                <template v-else-if="isVideo(moznost.subor)">
                    <skoly-ulohy-kvizova-otazka-video-thumbnail :subor="moznost.subor" />
                    <span class="play-btn" @click="showVideo(moznost.subor)"><span class="icon icon--play"></span></span>
                </template>
                <template v-else-if="isAudio(moznost.subor)">
                    <p class="text-21 mb-15">{{ moznost.hodnota }}</p>
                    <skoly-ulohy-kvizova-otazka-audio :subor="moznost.subor" />
                </template>
                <template v-else>
                    {{ moznost.hodnota }}
                </template>
            </label>
        </div>

    </div>
</template>

<script>
import EventService from "@/services/EventService";
import SkolyUlohyKvizovaOtazkaAudio from "@/components/skoly/SkolyUlohyKvizovaOtazkaAudio.vue";
import SkolyUlohyKvizovaOtazkaVideo from "@/components/skoly/SkolyUlohyKvizovaOtazkaVideo.vue";
import SkolyUlohyKvizovaOtazkaVideoThumbnail from "@/components/skoly/SkolyUlohyKvizovaOtazkaVideoThumbnail.vue";
import multimedia from "@/mixins/multimedia";

export default {
    components: {SkolyUlohyKvizovaOtazkaVideoThumbnail, SkolyUlohyKvizovaOtazkaVideo, SkolyUlohyKvizovaOtazkaAudio},
    props: [
        'otazka',
        'showResult',
        'odpoved'
    ],
    mixins: [ multimedia ],
    data() {
        return {
            videoToPlay: '',
            options: {controls: [], clickToPlay: false, autoplay: false, muted: true}
        }
    },
    computed: {
        skolyStorage() {
            return EventService.getUlohyStorageUrl()
        },
    },
    methods: {
        showVideo(subor) {
            this.$emit('playVideo', subor)
        }
    }
}
</script>
